import { ExpenseItemService } from "./../../../services/catalogs/ExpenseItemService";
import React from "react";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { ExpenseItemDetail } from "../../../components/Pages/Catalogs/ExpenseItem/ExpenseItemDetail";
import { CreateExpenseItemDto } from "../../../dtos/catalogs/ExpenseItem/CreateExpenseItemDto";
import { NFLookupExpenseItem } from "../../../components/Shared/NewForms/NFLookupExpenseItem";
import ExpenseItemList from "../../../components/Pages/Catalogs/ExpenseItem/ExpenseItemList";

export const ExpenseItem: IAppEntity = {
  entityType: "catalog",
  title: "Expense Item",
  pluralTitle: "Expense Item",
  apiUrl: "ExpenseItems",
  apiEnum: ReferenceTypes.CatalogExpenseItem,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(ExpenseItemDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ExpenseItemList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupExpenseItem, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new ExpenseItemService("ExpenseItems"),
  getEmptyModel: () => {
    const model: CreateExpenseItemDto = {
      name: "",
      createdDate: new Date(),
    };
    return model;
  },
};
